import React from 'react';
import styled from 'styled-components';
import { config } from './../../config/config';
import { CalculatorSection } from './../Calculators/Sections';
import { TextInput, RangerInput, RadioButton, InfoTip } from './../Form/index';
import { toPounds } from './../../services/Formats';

const { colorConfig } = config();

export const GreenLabel = styled.div`
  padding-top: 10px;
  padding-bottom: 20px;
  font-family: 'Nunito Sans',arial;
  font-weight: bold;
  color: ${colorConfig.main}
`;

export const HousePriceChange = ({ input, onChangeInput }) => (
  <CalculatorSection style={{ margin: '30px auto', width: '80%' }}>
    <div className="label" style={{ textAlign: 'center', fontSize: 14 }}>
      <strong>Select an average annual % house price decrease or increase over 15 years</strong>
      <br />
      and see how that can affect the equity protected in your home:
    </div>
    <div style={{ paddingTop: 10 }}>
      <RangerInput
        className="ranger"
        value={input.futureHousePricePct} min={-5} max={5} div={4} type='float'
        inactiveColor='#bbbbbb' withLabel={true} suffix="%"
        onChange={val => { onChangeInput('futureHousePricePct', val) }}
      />
    </div>
  </CalculatorSection>
);

const tooltip = 'An enhanced lifetime mortgage is available to clients who ' +
  'qualify due to existing medical conditions or lifestyle choices ' +
  'and want the maximum amount available. The LTVs are ' +
  'dependent on your client’s health – based on our 13-question ' +
  'health and lifestyle questionnaire. The more severe their life ' +
  'impairment the greater the tax free lump sum that could be';

export const ClientDetails = ({ input, output, onChangeInput }) => (
  <CalculatorSection icon='loan2019'>
    <div className="title">Client Details</div>
    <div className="section-row" style={{ paddingTop: 10 }}>
      <div className="pad">
        <div className="label">Age <small>(youngest if in couple)</small></div>

        <RangerInput
          className="ranger"
          style={{ width: 150 }}
          value={input.clientAge} min={55} max={89} withLabel={true}
          color={colorConfig.main} inactiveColor='#bbbbbb'
          onChange={val => { onChangeInput('clientAge', val) }}
        />

      </div>
    </div>
    <div className="section-row">
      <div className="pad">
        <div className="label">Value of home</div>
        <div>
          <TextInput
            width={150} style={{ textAlign: 'right' }}
            type="currency" prefixes="&pound;" value={input.housePrice}
            onChange={val => { onChangeInput('housePrice', val) }} />
        </div>
      </div>
    </div>
    <div className="section-row">
      <div className="column" style={{ padding: '0px 20px' }}>
        <div className="label">
          Does your client qualify for an enhanced LTV?
        </div>
        <div style={{ paddingTop: 5, paddingBottom: 0, display: 'flex' }}>

          <RadioButton
            value={true}
            checked={input.qualifyForEnhancedLtv === true}
            onChange={() => onChangeInput('qualifyForEnhancedLtv', true)}
          >
            Yes
            <InfoTip value={tooltip} />
          </RadioButton>
          <RadioButton
            value={false}
            checked={input.qualifyForEnhancedLtv === false}
            onChange={() => onChangeInput('qualifyForEnhancedLtv', false)}
          >
            No
          </RadioButton>

        </div>
      </div>
    </div>
    <div className="section-row">
      <div className="pad">
        <div className="label">
          Total loan available
        </div>
        <GreenLabel style={{ paddingRight: 10 }}>
          {toPounds(output.maxLoan)}
        </GreenLabel>
      </div>
    </div>
    <div className="section-row">
      <div className="pad">
        <div className="label">
          Total equity released
        </div>
        <div>
          <TextInput
            width={150} style={{ textAlign: 'right' }}
            type="currency" prefixes="&pound;"
            value={input.totalEquityReleased}
            onChange={val => { onChangeInput('totalEquityReleased', val) }}
          />
        </div>
      </div>
    </div>

    <div className="section-row">
      <div className="pad">
        <div className="label">
          % of loan taken
        </div>
        <GreenLabel style={{ paddingRight: 10, paddingBottom: 10 }}>
          {(!isNaN(parseInt(100 - 100 * output.offeredNotTaken, 10))) ? (
            <span>{parseInt(100 - (100 * output.offeredNotTaken), 10)}%</span>
          ): false}
        </GreenLabel>
      </div>
    </div>

    <div className="section-row">
      <div className="pad">
        <div className="label">
          Annual % house<br />price change
        </div>
        <RangerInput
          className="ranger"
          style={{ width: 150 }}
          value={input.futureHousePricePct} min={-5} max={5} div={4} type='float'
          color={colorConfig.main} inactiveColor='#bbbbbb' withLabel={true} suffix="%"
          onChange={val => { onChangeInput('futureHousePricePct', val) }}
        />
      </div>
    </div>

  </CalculatorSection>
);



// WEBPACK FOOTER //
// ./src/components/GuaranteedInheritance/Panel.js